import { atom, useRecoilValue, useSetRecoilState } from 'recoil'

import { localStorageEffect } from '@/capacitor/recoil/localstorage-effect'

const languages = [
  { code: 'nl', name: 'Nederlands' },
  { code: 'en', name: 'English' },
  { code: 'fr', name: 'Français' },
] as const

/**
 * Supported locales
 */
export type Locale = (typeof languages)[number]['code']

/**
 * Language state atom
 */
export const localeState = atom<Locale>({
  key: 'localeState',
  default: 'nl',
  effects: [localStorageEffect('@app/locale')],
})

export const useSetLocale = () => useSetRecoilState(localeState)

export const useLocale = () => useRecoilValue(localeState)
